module.exports = __webpack_public_path__ + "img/0ae9a9f.jpg";